import { useFormContext, useFormField } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { PrivacyPolicyCheckbox as Checkbox } from '../../../components/PrivacyPolicyCheckbox';
import { FormField } from '../../../components/FormField';
import { useFieldError } from '../../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var PrivacyPolicyCheckbox = function PrivacyPolicyCheckbox(props) {
  var name = props.name;
  var _useFormContext = useFormContext(),
    isSubmitting = _useFormContext.isSubmitting,
    values = _useFormContext.values;
  var _useFieldError = useFieldError(name),
    hideError = _useFieldError.hideError,
    errorMessage = _useFieldError.errorMessage;
  var _useFormField = useFormField({
      name: name
    }),
    _useFormField$field = _useFormField.field,
    checked = _useFormField$field.value,
    onBlur = _useFormField$field.onBlur,
    _useFormField$helpers = _useFormField.helpers,
    setValue = _useFormField$helpers.setValue,
    setError = _useFormField$helpers.setError;
  var handleChange = React.useCallback(function (event, value) {
    setValue(value);
    hideError();
    setError(undefined);
  }, [setError, hideError, setValue]);
  if (!values.abstractWithPrivacyPolicy) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormField, {
    errorMessage: errorMessage,
    children: function children() {
      return /*#__PURE__*/_jsx(Checkbox, {
        name: name,
        checked: !!checked,
        disabled: isSubmitting,
        invalid: !!errorMessage,
        onChange: handleChange,
        onBlur: onBlur
      });
    }
  });
};